import axios, { Method, BaseURL } from '@/apps/open/utils/axios'

const isPrivate = process.env.VUE_APP_IS_PRIVATE

const searchUserTypeMap: any = {
  admin: 1,
  user: 0
}

/**
 * 用户信息
 */
export function getUserInfo () {
  return axios({ url: '/api/login_info', method: Method.Get })
}

/**
 * 退出登录
 */
export function logout () {
  return axios({ url: '/p/logout', method: Method.Post, baseURL: isPrivate ? '' : BaseURL.Account })
}

/**
 * 搜索用户
 * @param userid
 * @param type
 */
export async function searchUser (userid: number, type: string, developer_id: number | string) {
  return axios({ url: '/api/my/user/search', method: Method.Get, params: { userid: userid, type: searchUserTypeMap[type], developer_id } })
}

/**
 * 发送短信验证码
 * @param params
 */
export async function sendSms (params: any) {
  return axios({ url: '/api/sms/captcha', method: Method.Post, data: params })
}

/**
 * 手机验证
 * @param params
 */
export async function verifyPhone (params: any) {
  return axios({ url: '/api/sms/captcha', method: Method.Put, data: params })
}
